import { Loader2 } from "lucide-react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children }) {
    const { status, user } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return (
            <div
                className="min-h-screen bg-paper flex items-center justify-center"
                data-testid="auth-loading"
            >
                <Loader2 className="w-6 h-6 animate-spin text-terracotta" />
            </div>
        );
    }
    if (status !== "authenticated") {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    // Force onboarding until it's completed.
    const isOnboarded = user?.onboarded;
    if (!isOnboarded && location.pathname !== "/onboarding" && !location.pathname.startsWith("/placement")) {
        return <Navigate to="/onboarding" replace />;
    }
    return children;
}

export function GuestOnlyRoute({ children }) {
    const { status } = useAuth();
    if (status === "loading") {
        return (
            <div className="min-h-screen bg-paper flex items-center justify-center">
                <Loader2 className="w-6 h-6 animate-spin text-terracotta" />
            </div>
        );
    }
    if (status === "authenticated") return <Navigate to="/dashboard" replace />;
    return children;
}
